import React from 'react';
import { withStyles, Grid, ButtonBase, } from '@material-ui/core';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';

const ICON_SHARE_DOWN = require("../../images/change/share.png");
const ICON_CLOSE = require("../../images/bg/guanbi_icon.png");

class Download extends React.Component {

    constructor() {
        super();
        this.state = {
            show: true,
        }
    }
    componentDidMount() {
        if (AppData.ShareUrl == '') {
            AppData.getShareConfig()
        }

    }

    _isIos = () => {
        var u = navigator.userAgent;
        if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
            return true;
        }
        return false;
    }

    _onDownload = () => {
        AppUtils.openUrl(AppData.ShareUrl)
        AppUtils.YMPush('DOWNLOAD', '首页下载');
    }

    onClose = (e) => {
        e.stopPropagation();
        this.setState({ show: false })
    }

    render() {
        const { classes } = this.props;
        const { show } = this.state;
        if (!show) {
            return (
                <div></div>
            );
        }
        return (
            <Grid style={{ lineHeight: 1, height: 36 }}>
                <ButtonBase onClick={() => this._onDownload()} className={classes.downbtn}>
                    <img src={ICON_CLOSE} onClick={(e) => this.onClose(e)}
                        style={{ width: 14, height: 14, position: 'absolute', right: 8, top: 11 }} />
                </ButtonBase>
            </Grid >
        );
    }
}

export default withStyles((theme) => ({
    downbtn: {
        width: '100vw',
        height: 36,
        backgroundSize: 'cover',
        backgroundImage: `url(${ICON_SHARE_DOWN})`,
    }
}))(Download);